import { useEffect, useMemo } from "react";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import Text from "../../../../../../../components/Inputs/Text";

function Search({ defaultData, setFilteredData }) {
    const { t } = useTranslation();

    const onSearchChange = useMemo(
        () =>
            debounce((e) => {
                const searchValue = e.target.value.toLowerCase();
                if (!searchValue.trim()) {
                    setFilteredData(defaultData);
                }

                const filtered = (defaultData || [])?.filter((item) => {
                    return (
                        item.code?.toLowerCase().includes(searchValue) ||
                        item.description?.toLowerCase().includes(searchValue) ||
                        item.glSegment?.toLowerCase().includes(searchValue) ||
                        item.name?.toLowerCase().includes(searchValue) ||
                        item.firstName?.toLowerCase().includes(searchValue) ||
                        item.lastName?.toLowerCase().includes(searchValue)
                    );
                });
                setFilteredData(filtered);
            }, 500),
        [defaultData, setFilteredData]
    );

    useEffect(() => {
        return () => onSearchChange.cancel();
    }, [onSearchChange]);

    return (
        <Text
            className="w-75"
            placeholder={t("search") + "..."}
            onChange={onSearchChange}
        />
    );
}

export default Search;
